import { SignalDispatcher } from 'ste-signals';

export const trackerEvents = {
  onAdded: new SignalDispatcher(),
  onRemoved: new SignalDispatcher(),
};
